<script setup lang="ts">
import { useModalStore } from 'Helpers/modal';

const { modalList } = useModalStore();
</script>

<template>
  <component
    :is="modalData.component"
    v-for="(modalData, index) in modalList"
    :key="index"
    show
    v-bind="{ ...modalData.props, ...modalData.callbacks }"
  />
</template>

<style lang="sass" scoped>
</style>
